import {
  IconButton,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightAddon,
} from '@chakra-ui/react';
import { BiSearch } from 'react-icons/bi';
import { FaTable } from 'react-icons/fa';

interface RangeSelectionProps {
  range: string;
  setRange: (range: string) => void;
}
const RangeSelection: React.FC<RangeSelectionProps> = ({ range, setRange }) => {
  return (
    <InputGroup size="sm">
      <InputLeftAddon rounded="2xl">Applies to</InputLeftAddon>
      <Input
        type="text"
        value={range}
        onChange={(e) => setRange(e.target.value)}
      />
      <InputRightAddon
        rounded="2xl"
        padding="0px"
        children={
          <IconButton
            variant="ghost"
            rounded="2xl"
            size="sm"
            icon={<FaTable />}
            aria-label="bi-search"
          />
        }
      />
    </InputGroup>
  );
};

export default RangeSelection;
